import {useEffect} from 'react';

const useFitBounds = (mapInstance, focusedGeofence, fitEnlarged = false) => {
    useEffect(() => {
        if (mapInstance && focusedGeofence) {
            const bounds = new window.google.maps.LatLngBounds();
            const points = fitEnlarged && focusedGeofence.enlargedPoints ? focusedGeofence.enlargedPoints : focusedGeofence.points;

            points.forEach(point => {
                bounds.extend(new window.google.maps.LatLng(point.latitude, point.longitude));
            });

            mapInstance.fitBounds(bounds);
        }
    }, [mapInstance, focusedGeofence]);
};

export default useFitBounds;